module.exports = __webpack_public_path__ + "img/icon-windows.b293ef45.svg";